// main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './composables/useTheme';
import './services/axios';
import { msalInstance, initializeMsal } from '@/composables/msalConfig';
import GlobalAlert from './components/GlobalAlert.vue';
import PrimeVue from 'primevue/config';

import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'primevue/resources/themes/aura-light-green/theme.css';
import './assets/custom.css';

import './registerServiceWorker';
import * as bootstrap from 'bootstrap';
import { setZXingModuleOverrides } from 'vue-qrcode-reader';
window.bootstrap = bootstrap;

// vue-qrcode-reader only uses the browser's native BarcodeDetector when it
// supports EVERY format the scanner asks for. The material scanner asks for
// code_128 and the EAN formats on top of qr_code, so on a phone whose native
// detector is missing or narrower -- no Google Play Services, or the barcode
// module not yet downloaded -- the whole scan falls back to a WASM decoder that
// the library otherwise fetches from fastly.jsdelivr.net the first time it
// decodes. A technician in a van on a filtered or flaky connection then gets a
// camera that previews perfectly and never reads anything, with no error to
// show for it. Serve the file ourselves so it is same-origin and cacheable.
//
// Pinned by hand: this must stay the zxing-wasm version whose JS glue
// vue-qrcode-reader bundles (1.1.3 as of vue-qrcode-reader@5.5.10). After any
// upgrade of that package, grep its dist bundle for "zxing-wasm@" and re-copy
// node_modules/zxing-wasm/dist/reader/zxing_reader.wasm into public/zxing/ if
// the version moved -- a mismatched .wasm fails at instantiation.
setZXingModuleOverrides({
    locateFile: (path, prefix) =>
        path.endsWith('.wasm') ? `${process.env.BASE_URL}zxing/zxing_reader.wasm` : prefix + path,
});

(async () => {
    try {
        // 1) Init MSAL runtime
        await initializeMsal();

        // 2) Handle login redirect ONCE per tab (must be before mount)
        const result = await msalInstance.handleRedirectPromise();
        if (result?.account) {
            msalInstance.setActiveAccount(result.account);
        }

        // 3) If user was already logged in in another tab, pick the existing account
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length && !msalInstance.getActiveAccount()) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        // 4) (Optional) react to login/logout from other tabs
        window.addEventListener('storage', (e) => {
            if (e.key && e.key.startsWith('msal.')) {
                const accs = msalInstance.getAllAccounts();
                msalInstance.setActiveAccount(accs[0] || null);
                // trigger your store/auth refresh here if you keep user state
            }
        });

        // 5) Mount the app only after MSAL state is ready
        createApp(App)
            .use(router)
            .use(i18n)
            .use(PrimeVue, {
                zIndex: { modal: 1100, overlay: 1100, menu: 1100, tooltip: 1100 }
            })
            .component('global-alert', GlobalAlert)
            .mount('#app');

    } catch (err) {
        console.error('Error booting app/MSAL:', err);
    }
})();
